import { CircularProgress, Grid, TableContainer } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import { useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CreateIcon from '@material-ui/icons/Create';
import AppContext from '../../../../../App/AppContext';
import { addupdateFPInterestRates, getReportingFPInterestRates } from '../../../../../Core/Service/ReportScreens-service';
import formatters from '../../../../../Core/Grid/inputFormatter';
import moment from 'moment';

const useStyles = makeStyles({
    table: {
        minWidth: 1250,
        '& .MuiTableCell-root': {
            padding: '10px 5px'
        }
    },
    tableRowStyle: {
        backgroundColor: '#E0E0E0'
    },
    totalsContainerStyle: {
        fontWeight: 600
    }
});

const MonthShortNameList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const NewUsedReportingBudgetTable = (props) => {
    const [state, setState] = useState({
        isRecords: false,
        rows: [],
        isActive: false,
        category: '',
        columnTotal: {},
        rows: [],
        calculatedRows: [],
        isActive: false,
        totals: {},
        changeRecordIds: [],
        isChangeTrig: false
    });
    const [modelTypeList, setModelTypeList] = useState([]);
    const [showCircularLoader, setShowCircularLoader] = useState(true);
    const [calculatedExpenseList, setCalculatedExpenseList] = useState([]);
    const { showToast } = useContext(AppContext);
    const classes = useStyles();

    const pullExpenseBudgetGridData = async () => {
        setShowCircularLoader(true);
        let sortedModelList = props.modelList.map((q) => ({ ...q, data: [] }));

        let res = await getReportingFPInterestRates(props.yearCode?.id);
        let tempResData = res.data || [];
        if (sortedModelList.length > 0) {
            tempResData.forEach((p) => {
                let objIndex = sortedModelList.findIndex((o) => o.providerID == p.providerID);
                if (objIndex > -1) {
                    sortedModelList[objIndex].data.push({ ...p });
                } else {
                    sortedModelList.push({
                        providerID: p.providerID,
                        name: p.name,
                        data: [{ ...p }]
                    });
                }
            });

            sortedModelList.forEach((r) => {
                let list2 = MonthShortNameList.map((m) => {
                    let obj = r.data.find((p) => moment(p.td).format('DD-MMM-YYYY').includes(`${m}`));
                    if (obj) {
                        return obj;
                    } else {
                        return {
                            providerID: r.providerID,
                            id: null,
                            name: r.name,
                            td: moment(`01/${m}/${props.yearCode?.id}`).format('DD-MMM-YYYY'),
                            ir: 0
                        };
                    }
                });
                r.data = list2;
            });

            setState((st) => {
                return { ...st, isRecords: true, isChangeTrig: false };
            });
        } else {
            setState((st) => {
                return { ...st, isRecords: false };
            });
        }
        setModelTypeList(sortedModelList);
        setShowCircularLoader(false);
    };

    useEffect(() => {
        if (props.yearCode?.id) {
            pullExpenseBudgetGridData();
        }
    }, [props.yearCode?.id, props.modelList]);

    useEffect(() => {
        props.handleActionTriggerCheck(state.isChangeTrig);
    }, [state.isChangeTrig]);

    useEffect(() => {
        let tempArr = [...modelTypeList];
        // tempArr.forEach((t) => {
        //     let IRTotal = 0;
        //     t.data.forEach((q) => {
        //         IRTotal += +q.ir;
        //     });
        //     t.allIRAmount = IRTotal;
        // });

        // let colCalculation = {
        //     modelTypeJanIRTotal: 0,
        //     modelTypeFebIRTotal: 0,
        //     modelTypeMarIRTotal: 0,
        //     modelTypeAprIRTotal: 0,
        //     modelTypeMayIRTotal: 0,
        //     modelTypeJunIRTotal: 0,
        //     modelTypeJulIRTotal: 0,
        //     modelTypeAugIRTotal: 0,
        //     modelTypeSepIRTotal: 0,
        //     modelTypeOctIRTotal: 0,
        //     modelTypeNovIRTotal: 0,
        //     modelTypeDecIRTotal: 0,
        //     modelTypeIRTotalTotal: 0
        // };
        // let IRTotals = 0;
        // tempArr.forEach((w) => {
        //     IRTotals += w.allIRAmount;
        //     w.data.forEach((q) => {
        //         MonthShortNameList.map((m) => {
        //             if (moment(q.td).format('DD-MMM-YYYY').includes(`${m}`)) {
        //                 colCalculation[`modelType${m}IRTotal`] += q.ir;
        //             }
        //         });
        //     });
        //     colCalculation.modelTypeIRTotalTotal = IRTotals;
        // });
        // tempArr.push({ name: 'Total', data: colCalculation });

        setCalculatedExpenseList(tempArr);
    }, [modelTypeList]);

    const gridInputChangeHandler = (index, providerID) => (e) => {
        let tempList = [...modelTypeList];
        let objIndex = tempList.findIndex((x) => x.providerID == providerID);
        tempList[objIndex].data[index] = {
            ...tempList[objIndex].data[index],
            [e.target.name]: +e.target.value,
            isChanged: true
        };

        setModelTypeList(tempList);
        setState((st) => {
            return { ...st, isChangeTrig: true };
        });
    };

    const InputWrapper = (index, providerID, TargetUnits) => {
        return (
            <div style={{ display: 'flex' }}>
                <input
                    title={`${TargetUnits}`}
                    type="number"
                    name={'ir'}
                    onChange={gridInputChangeHandler(index, providerID)}
                    value={TargetUnits}
                    className="pa-4"
                    // style={{ textAlign: 'right', width: '50%' }}
                />
            </div>
        );
    };

    const handleSubmit = async () => {
        let tempModelTypeList = [...modelTypeList];

        let data = [];
        tempModelTypeList.forEach((f) => {
            let tempData = f.data
                .filter((j) => j.isChanged)
                .map(({ expenseCategoryName, isChanged, ...q }) => ({
                    FPInterestRateInterestRate: q.ir,
                    FPInterestRateProviderID: q.providerID,
                    FPInterestRateDate: q.td,
                    FPInterestRateID: q.id
                }));
            data = [...data, ...tempData];
        });

        let filterPostData = {
            FPIntrestTargets: data
        };

        let res = await addupdateFPInterestRates(filterPostData);
        if (res.success) {
            showToast('Save Successfully');
            pullExpenseBudgetGridData();
        }
    };

    useEffect(() => {
        props.childFunc.current = handleSubmit;
    }, [modelTypeList]);

    return (
        <Grid container spacing={2} style={{ paddingTop: '10px' }} justifyContent="center">
            {showCircularLoader ? (
                <Grid item>
                    <CircularProgress />
                </Grid>
            ) : (
                <Grid item xs={12}>
                    <TableContainer component={Paper} style={{ maxHeight: 'calc(100vh - 320px)' }} className="input-Number-remove-spinners">
                        <Table className={classes.table} stickyHeader aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell width={20}></TableCell>
                                    <TableCell width={120}>Finance Company</TableCell>
                                    {MonthShortNameList.map((p) => {
                                        return (
                                            <TableCell align="center">
                                                <div>{p}</div>
                                            </TableCell>
                                        );
                                    })}
                                    {/* <TableCell width={100} align="right">
                                        <div> Total</div>
                                    </TableCell> */}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {!state.isRecords ? (
                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                            No Records
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    <>
                                        {calculatedExpenseList.map((t) => {
                                            return (
                                                <>
                                                    {!t.providerID ? (
                                                        <TableRow>
                                                            <TableCell></TableCell>

                                                            <TableCell component="th" scope="row" className={classes.totalsContainerStyle}>
                                                                {t.name}
                                                            </TableCell>
                                                            {MonthShortNameList.map((p) => {
                                                                return (
                                                                    <TableCell align="center" className={classes.totalsContainerStyle}>
                                                                        {formatters.ThousandSeparatorWithoutZero(t.data[`modelType${p}IRTotal`])}
                                                                    </TableCell>
                                                                );
                                                            })}

                                                            <TableCell align="right" className={classes.totalsContainerStyle}>
                                                                {formatters.ThousandSeparatorWithoutZero(t.data.modelTypeIRTotalTotal)}
                                                            </TableCell>
                                                        </TableRow>
                                                    ) : (
                                                        <TableRow>
                                                            <TableCell>
                                                                <CreateIcon
                                                                    fontSize="small"
                                                                    color="secondary"
                                                                    style={{ verticalAlign: 'center', cursor: 'pointer' }}
                                                                    onClick={() => props.handleModelOpen(t.providerID)}
                                                                />
                                                            </TableCell>

                                                            <TableCell component="th" scope="row">
                                                                {t.name}
                                                            </TableCell>

                                                            {t.data.map((p, i) => {
                                                                return <TableCell align="center">{InputWrapper(i, t.providerID, p.ir)}</TableCell>;
                                                            })}

                                                            {/* <TableCell align="right" className={classes.totalsContainerStyle}>
                                                                {formatters.ThousandSeparatorWithoutZero(t.allIRAmount)}
                                                            </TableCell> */}
                                                        </TableRow>
                                                    )}
                                                </>
                                            );
                                        })}
                                    </>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            )}
        </Grid>
    );
};

export default NewUsedReportingBudgetTable;
